import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const StyledTable = /*#__PURE__*/_styled("table", {
  target: "e2gq61v0",
  label: "StyledTable"
})(process.env.NODE_ENV === "production" ? {
  name: "1ewy569",
  styles: "border-collapse:collapse;margin-bottom:16px;width:100%"
} : {
  name: "1ewy569",
  styles: "border-collapse:collapse;margin-bottom:16px;width:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9SaWNodGV4dENvbnRyb2wvY29tcG9uZW50cy9FbGVtZW50L1RhYmxlRWxlbWVudC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFZ0MiLCJmaWxlIjoiLi4vLi4vLi4vLi4vLi4vc3JjL1JpY2h0ZXh0Q29udHJvbC9jb21wb25lbnRzL0VsZW1lbnQvVGFibGVFbGVtZW50LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5jb25zdCBTdHlsZWRUYWJsZSA9IHN0eWxlZC50YWJsZWBcbiAgYm9yZGVyLWNvbGxhcHNlOiBjb2xsYXBzZTtcbiAgbWFyZ2luLWJvdHRvbTogMTZweDtcbiAgd2lkdGg6IDEwMCU7XG5gO1xuXG5mdW5jdGlvbiBUYWJsZUVsZW1lbnQoeyBjaGlsZHJlbiwgYXR0cmlidXRlcywgbm9kZVByb3BzIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8U3R5bGVkVGFibGUgey4uLmF0dHJpYnV0ZXN9IHsuLi5ub2RlUHJvcHN9PlxuICAgICAgPHRib2R5PntjaGlsZHJlbn08L3Rib2R5PlxuICAgIDwvU3R5bGVkVGFibGU+XG4gICk7XG59XG5cbmV4cG9ydCBkZWZhdWx0IFRhYmxlRWxlbWVudDtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
function TableElement({
  children,
  attributes,
  nodeProps
}) {
  return _jsx(StyledTable, {
    ...attributes,
    ...nodeProps,
    children: _jsx("tbody", {
      children: children
    })
  });
}
export default TableElement;